export default __webpack_public_path__ + "static/media/digital_marketing.6c6bf638.png";